// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Icons$LiteracyplanetClientSxEntry from "./Icons.res.mjs";
import * as ModernStyles$LiteracyplanetClientSxEntry from "./ModernStyles.res.mjs";
import * as JourneyHeaderIcons$LiteracyplanetClientSxEntry from "./JourneyHeaderIcons.res.mjs";

function ModernComponents$HeaderBackground(props) {
  return React.createElement("div", {
              className: ModernStyles$LiteracyplanetClientSxEntry.HeaderBackground.className
            }, props.children);
}

var HeaderBackground = {
  make: ModernComponents$HeaderBackground
};

function ModernComponents$HeaderPanel(props) {
  return React.createElement("div", {
              className: ModernStyles$LiteracyplanetClientSxEntry.HeaderPanel.className
            }, props.children);
}

var HeaderPanel = {
  make: ModernComponents$HeaderPanel
};

function ModernComponents$SlimHeaderItemIcon(props) {
  return React.createElement("div", {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimHeaderItemIcon.className
            }, props.children);
}

var SlimHeaderItemIcon = {
  make: ModernComponents$SlimHeaderItemIcon
};

function ModernComponents$AcademyIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Academy.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var AcademyIcon = {
  make: ModernComponents$AcademyIcon
};

function ModernComponents$WordFlyersIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.WordFlyers.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var WordFlyersIcon = {
  make: ModernComponents$WordFlyersIcon
};

function ModernComponents$PlanetIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Planet.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var PlanetIcon = {
  make: ModernComponents$PlanetIcon
};

function ModernComponents$ChestIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Chest.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var ChestIcon = {
  make: ModernComponents$ChestIcon
};

function ModernComponents$AvatarIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Avatar.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var AvatarIcon = {
  make: ModernComponents$AvatarIcon
};

function ModernComponents$LetterAIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Lettera.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var LetterAIcon = {
  make: ModernComponents$LetterAIcon
};

function ModernComponents$ArcadeIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Arcade.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var ArcadeIcon = {
  make: ModernComponents$ArcadeIcon
};

function ModernComponents$MyWordsIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.MyWords.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var MyWordsIcon = {
  make: ModernComponents$MyWordsIcon
};

function ModernComponents$MagazineIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Magazine.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var MagazineIcon = {
  make: ModernComponents$MagazineIcon
};

function ModernComponents$MagazineDropdownIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Magazine.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.DropdownHeaderIcon.className
            });
}

var MagazineDropdownIcon = {
  make: ModernComponents$MagazineDropdownIcon
};

function ModernComponents$BookDropdownIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Book.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.DropdownHeaderIcon.className
            });
}

var BookDropdownIcon = {
  make: ModernComponents$BookDropdownIcon
};

function ModernComponents$LibraryIcon(props) {
  return React.createElement(JourneyHeaderIcons$LiteracyplanetClientSxEntry.Library.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var LibraryIcon = {
  make: ModernComponents$LibraryIcon
};

function ModernComponents$SlimHeaderItemButton(props) {
  return React.createElement("div", {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimHeaderItemButton.className(props.highlight, props.itemColor, props.hoverColor, props.activeColor)
            }, props.children);
}

var SlimHeaderItemButton = {
  make: ModernComponents$SlimHeaderItemButton
};

function ModernComponents$SlimHeaderItem(props) {
  return React.createElement("div", {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimHeaderItem.className,
              onClick: props.onClick
            }, props.children);
}

var SlimHeaderItem = {
  make: ModernComponents$SlimHeaderItem
};

function ModernComponents$SlimHeaderLockIcon(props) {
  return React.createElement(Icons$LiteracyplanetClientSxEntry.LockSmallIcon.make, {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimHeaderLockIcon.className
            });
}

var SlimHeaderLockIcon = {
  make: ModernComponents$SlimHeaderLockIcon
};

function ModernComponents$SlimHeaderNotificationCount(props) {
  return React.createElement("div", {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimHeaderNotificationCount.className
            }, String(props.count));
}

var SlimHeaderNotificationCount = {
  make: ModernComponents$SlimHeaderNotificationCount
};

function ModernComponents$SlimHeaderItemWrapper(props) {
  return React.createElement("div", {
              className: ModernStyles$LiteracyplanetClientSxEntry.SlimHeaderItemWrapper.className
            }, props.children);
}

var SlimHeaderItemWrapper = {
  make: ModernComponents$SlimHeaderItemWrapper
};

function ModernComponents$AcademySlimHeaderItem(props) {
  return React.createElement(ModernComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(ModernComponents$SlimHeaderItemButton, {
                  children: ModernStyles$LiteracyplanetClientSxEntry.s("Academy"),
                  itemColor: ModernStyles$LiteracyplanetClientSxEntry.missionsColor,
                  hoverColor: ModernStyles$LiteracyplanetClientSxEntry.missionsHoverColor,
                  activeColor: ModernStyles$LiteracyplanetClientSxEntry.missionsActiveColor,
                  highlight: props.highlight
                }), React.createElement(ModernComponents$SlimHeaderItemIcon, {
                  children: React.createElement(ModernComponents$SlimHeaderItemWrapper, {
                        children: React.createElement(ModernComponents$AcademyIcon, {})
                      })
                }));
}

var AcademySlimHeaderItem = {
  make: ModernComponents$AcademySlimHeaderItem
};

function ModernComponents$WordFlyersSlimHeaderItem(props) {
  return React.createElement(ModernComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(ModernComponents$SlimHeaderItemButton, {
                  children: ModernStyles$LiteracyplanetClientSxEntry.s("Word Flyers"),
                  itemColor: ModernStyles$LiteracyplanetClientSxEntry.missionsColor,
                  hoverColor: ModernStyles$LiteracyplanetClientSxEntry.missionsHoverColor,
                  activeColor: ModernStyles$LiteracyplanetClientSxEntry.missionsActiveColor,
                  highlight: props.highlight
                }), React.createElement(ModernComponents$SlimHeaderItemIcon, {
                  children: React.createElement(ModernComponents$SlimHeaderItemWrapper, {
                        children: React.createElement(ModernComponents$WordFlyersIcon, {})
                      })
                }));
}

var WordFlyersSlimHeaderItem = {
  make: ModernComponents$WordFlyersSlimHeaderItem
};

function ModernComponents$MissionsSlimHeaderItem(props) {
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  return React.createElement(ModernComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(ModernComponents$SlimHeaderItemButton, {
                  children: ModernStyles$LiteracyplanetClientSxEntry.s("Missions"),
                  itemColor: ModernStyles$LiteracyplanetClientSxEntry.missionsColor,
                  hoverColor: ModernStyles$LiteracyplanetClientSxEntry.missionsHoverColor,
                  activeColor: ModernStyles$LiteracyplanetClientSxEntry.missionsActiveColor,
                  highlight: props.highlight
                }), React.createElement(ModernComponents$SlimHeaderItemIcon, {
                  children: React.createElement(ModernComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(ModernComponents$PlanetIcon, {}), notificationCount > 0 ? React.createElement(ModernComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null)
                }));
}

var MissionsSlimHeaderItem = {
  make: ModernComponents$MissionsSlimHeaderItem
};

function ModernComponents$CollectionsSlimHeaderItem(props) {
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  return React.createElement(ModernComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(ModernComponents$SlimHeaderItemButton, {
                  children: ModernStyles$LiteracyplanetClientSxEntry.s("Collections"),
                  itemColor: ModernStyles$LiteracyplanetClientSxEntry.collectionsColor,
                  hoverColor: ModernStyles$LiteracyplanetClientSxEntry.collectionsHoverColor,
                  activeColor: ModernStyles$LiteracyplanetClientSxEntry.collectionsActiveColor,
                  highlight: props.highlight
                }), React.createElement(ModernComponents$SlimHeaderItemIcon, {
                  children: React.createElement(ModernComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(ModernComponents$ChestIcon, {}), notificationCount > 0 ? React.createElement(ModernComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null)
                }));
}

var CollectionsSlimHeaderItem = {
  make: ModernComponents$CollectionsSlimHeaderItem
};

function ModernComponents$ArcadeSlimHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(ModernComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(ModernComponents$SlimHeaderItemButton, {
                  children: ModernStyles$LiteracyplanetClientSxEntry.s("Arcade"),
                  itemColor: ModernStyles$LiteracyplanetClientSxEntry.arcadeColor,
                  hoverColor: ModernStyles$LiteracyplanetClientSxEntry.arcadeHoverColor,
                  activeColor: ModernStyles$LiteracyplanetClientSxEntry.arcadeActiveColor,
                  highlight: props.highlight
                }), React.createElement(ModernComponents$SlimHeaderItemIcon, {
                  children: React.createElement(ModernComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(ModernComponents$ArcadeIcon, {}), notificationCount > 0 ? React.createElement(ModernComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(ModernComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var ArcadeSlimHeaderItem = {
  make: ModernComponents$ArcadeSlimHeaderItem
};

function ModernComponents$AvatarSlimHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(ModernComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(ModernComponents$SlimHeaderItemButton, {
                  children: ModernStyles$LiteracyplanetClientSxEntry.s("Shop"),
                  itemColor: ModernStyles$LiteracyplanetClientSxEntry.avatarColor,
                  hoverColor: ModernStyles$LiteracyplanetClientSxEntry.avatarHoverColor,
                  activeColor: ModernStyles$LiteracyplanetClientSxEntry.avatarActiveColor,
                  highlight: props.highlight
                }), React.createElement(ModernComponents$SlimHeaderItemIcon, {
                  children: React.createElement(ModernComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(ModernComponents$AvatarIcon, {}), notificationCount > 0 ? React.createElement(ModernComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(ModernComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var AvatarSlimHeaderItem = {
  make: ModernComponents$AvatarSlimHeaderItem
};

function ModernComponents$MyWordsSlimHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(ModernComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(ModernComponents$SlimHeaderItemButton, {
                  children: ModernStyles$LiteracyplanetClientSxEntry.s("My Words"),
                  itemColor: ModernStyles$LiteracyplanetClientSxEntry.myWordsColor,
                  hoverColor: ModernStyles$LiteracyplanetClientSxEntry.myWordsHoverColor,
                  activeColor: ModernStyles$LiteracyplanetClientSxEntry.myWordsActiveColor,
                  highlight: props.highlight
                }), React.createElement(ModernComponents$SlimHeaderItemIcon, {
                  children: React.createElement(ModernComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(ModernComponents$MyWordsIcon, {}), notificationCount > 0 ? React.createElement(ModernComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(ModernComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var MyWordsSlimHeaderItem = {
  make: ModernComponents$MyWordsSlimHeaderItem
};

function ModernComponents$IntrepizineSlimHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(ModernComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(ModernComponents$SlimHeaderItemButton, {
                  children: ModernStyles$LiteracyplanetClientSxEntry.s("Intrepizine"),
                  itemColor: ModernStyles$LiteracyplanetClientSxEntry.libraryColor,
                  hoverColor: ModernStyles$LiteracyplanetClientSxEntry.libraryHoverColor,
                  activeColor: ModernStyles$LiteracyplanetClientSxEntry.libraryActiveColor,
                  highlight: props.highlight
                }), React.createElement(ModernComponents$SlimHeaderItemIcon, {
                  children: React.createElement(ModernComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(ModernComponents$MagazineIcon, {}), notificationCount > 0 ? React.createElement(ModernComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(ModernComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var IntrepizineSlimHeaderItem = {
  make: ModernComponents$IntrepizineSlimHeaderItem
};

function ModernComponents$DropdownHeaderPanel(props) {
  return React.createElement("div", {
              className: ModernStyles$LiteracyplanetClientSxEntry.DropdownHeaderPanel.className
            }, props.children);
}

var DropdownHeaderPanel = {
  make: ModernComponents$DropdownHeaderPanel
};

function ModernComponents$DropdownHeaderItem(props) {
  return React.createElement("div", {
              className: ModernStyles$LiteracyplanetClientSxEntry.DropdownHeaderItem.className,
              onClick: props.onClick
            }, props.children);
}

var DropdownHeaderItem = {
  make: ModernComponents$DropdownHeaderItem
};

function ModernComponents$BooksDropdownItem(props) {
  return React.createElement(ModernComponents$DropdownHeaderItem, {
              children: null,
              onClick: props.onClick
            }, React.createElement(ModernComponents$BookDropdownIcon, {}), ModernStyles$LiteracyplanetClientSxEntry.s("Books"));
}

var BooksDropdownItem = {
  make: ModernComponents$BooksDropdownItem
};

function ModernComponents$IntrepizineDropdownItem(props) {
  return React.createElement(ModernComponents$DropdownHeaderItem, {
              children: null,
              onClick: props.onClick
            }, React.createElement(ModernComponents$MagazineDropdownIcon, {}), ModernStyles$LiteracyplanetClientSxEntry.s("Intrepizine"));
}

var IntrepizineDropdownItem = {
  make: ModernComponents$IntrepizineDropdownItem
};

function ModernComponents$LibraryClosedHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(ModernComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(ModernComponents$SlimHeaderItemButton, {
                  children: ModernStyles$LiteracyplanetClientSxEntry.s("Library"),
                  itemColor: ModernStyles$LiteracyplanetClientSxEntry.libraryColor,
                  hoverColor: ModernStyles$LiteracyplanetClientSxEntry.libraryHoverColor,
                  activeColor: ModernStyles$LiteracyplanetClientSxEntry.libraryActiveColor,
                  highlight: props.highlight
                }), React.createElement(ModernComponents$SlimHeaderItemIcon, {
                  children: React.createElement(ModernComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(ModernComponents$LibraryIcon, {}), notificationCount > 0 ? React.createElement(ModernComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(ModernComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var LibraryClosedHeaderItem = {
  make: ModernComponents$LibraryClosedHeaderItem
};

function ModernComponents$LibraryOpenDropdown(props) {
  return React.createElement(ModernComponents$DropdownHeaderPanel, {
              children: null
            }, React.createElement(ModernComponents$BooksDropdownItem, {
                  onClick: props.onClickLibrary
                }), React.createElement(ModernComponents$IntrepizineDropdownItem, {
                  onClick: props.onClickIntrepizine
                }));
}

var LibraryOpenDropdown = {
  make: ModernComponents$LibraryOpenDropdown
};

function ModernComponents$LibrarySlimHeaderItem(props) {
  var openSubnav = props.openSubnav;
  var closeSubnav = props.closeSubnav;
  var onClickIntrepizine = props.onClickIntrepizine;
  var onClickLibrary = props.onClickLibrary;
  var highlightLibrary = props.highlightLibrary;
  var lockLibrary = props.lockLibrary;
  if (lockLibrary) {
    return React.createElement(ModernComponents$LibraryClosedHeaderItem, {
                highlight: highlightLibrary,
                onClick: (function (param) {
                    Curry._1(onClickIntrepizine, undefined);
                  }),
                lock: lockLibrary
              });
  } else if (props.subnavOpen) {
    return React.createElement("div", undefined, React.createElement(ModernComponents$LibraryClosedHeaderItem, {
                    highlight: highlightLibrary,
                    onClick: (function (param) {
                        Curry._1(closeSubnav, undefined);
                      }),
                    lock: lockLibrary
                  }), React.createElement(ModernComponents$LibraryOpenDropdown, {
                    onClickLibrary: (function (param) {
                        Curry._1(onClickLibrary, undefined);
                        Curry._1(closeSubnav, undefined);
                      }),
                    onClickIntrepizine: (function (param) {
                        Curry._1(onClickIntrepizine, undefined);
                        Curry._1(closeSubnav, undefined);
                      })
                  }));
  } else {
    return React.createElement(ModernComponents$LibraryClosedHeaderItem, {
                highlight: highlightLibrary,
                onClick: (function (param) {
                    Curry._1(openSubnav, undefined);
                  }),
                lock: lockLibrary
              });
  }
}

var LibrarySlimHeaderItem = {
  make: ModernComponents$LibrarySlimHeaderItem
};

export {
  HeaderBackground ,
  HeaderPanel ,
  SlimHeaderItemIcon ,
  AcademyIcon ,
  WordFlyersIcon ,
  PlanetIcon ,
  ChestIcon ,
  AvatarIcon ,
  LetterAIcon ,
  ArcadeIcon ,
  MyWordsIcon ,
  MagazineIcon ,
  MagazineDropdownIcon ,
  BookDropdownIcon ,
  LibraryIcon ,
  SlimHeaderItemButton ,
  SlimHeaderItem ,
  SlimHeaderLockIcon ,
  SlimHeaderNotificationCount ,
  SlimHeaderItemWrapper ,
  AcademySlimHeaderItem ,
  WordFlyersSlimHeaderItem ,
  MissionsSlimHeaderItem ,
  CollectionsSlimHeaderItem ,
  ArcadeSlimHeaderItem ,
  AvatarSlimHeaderItem ,
  MyWordsSlimHeaderItem ,
  IntrepizineSlimHeaderItem ,
  DropdownHeaderPanel ,
  DropdownHeaderItem ,
  BooksDropdownItem ,
  IntrepizineDropdownItem ,
  LibraryClosedHeaderItem ,
  LibraryOpenDropdown ,
  LibrarySlimHeaderItem ,
}
/* react Not a pure module */
